import { Box, Flex, Text } from "@chakra-ui/react";
import React from "react";

const BankAccountVisual = () => {
  return (
    <Flex
      borderColor="bored.input"
      borderWidth="1px"
      bg="bg.grey"
      borderRadius={4}
      justifyContent="space-between"
      p="16px"
    >
      <Box mx="8px">
        <Text color="text.grey" textStyle="bodySmall">
          Routing number
        </Text>
        <Flex placeItems="center">
          <svg
            width={8}
            height={11}
            viewBox="0 0 8 11"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M2.194 1.172H0v8.205h2.194V1.172zM7.68 0H4.39v3.517H7.68V0zM7.68 7.033H4.39v3.517H7.68V7.033z"
              fill="#6A6E74"
            />
          </svg>
          <Text ml="4px">123456789</Text>
        </Flex>
      </Box>
      <Box mx="8px">
        <Text color="text.grey" textStyle="bodySmall">
          Account number
        </Text>
        <Flex placeItems="center">
          <svg
            width={8}
            height={11}
            viewBox="0 0 8 11"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M2.194 1.172H0v8.205h2.194V1.172zM7.68 0H4.39v3.517H7.68V0zM7.68 7.033H4.39v3.517H7.68V7.033z"
              fill="#6A6E74"
            />
          </svg>
          <Text ml="4px">001234567</Text>
        </Flex>
      </Box>
      <Box mx="8px">
        <Text color="text.grey" textStyle="bodySmall">
          &nbsp;
        </Text>
        <Flex placeItems="center">
          <svg
            width={8}
            height={10}
            viewBox="0 0 8 10"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1.097 1.2H0v8.39h1.097V1.2zM3.29 1.2H2.194v8.39h1.098V1.2zM7.68 0H4.39v4.795H7.68V0z"
              fill="#6A6A6E"
            />
          </svg>
          <Text ml="4px">1000</Text>
        </Flex>
      </Box>
    </Flex>
  );
};

export default BankAccountVisual;
